export const PROGRESS_IMAGE_MAP = {
  0: '#C7E64E',
  25: '#C7E64E',
  50: '#C7E64E',
  75: '#C7E64E',
  100: '#C7E64E',
}

export const findClosestProgressValue = (progress) => [0, 25, 50, 75, 100].reduce((prev, curr) => (Math.abs(curr - progress) < Math.abs(prev - progress) ? curr : prev))
